import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
// import greetingCard from '../../assets/header-icons/sec_header_greeting.svg';
// import logo from '../../assets/header-icons/indexx_logo.svg';
import logo from '../../assets/header-icons/indexx-logo-v3-dark.svg';
// ZodiacDashboardLink is still exported by the launcher; the Dashboard itself
// is out of scope for now, so no header renders it.
import ZodiacLauncher from '../ZodiacLauncher/ZodiacLauncher';
// @ts-ignore — zodiacAuth.js is plain JS, synced from zodiac-embed, no types
import { notifySignedOut } from '../ZodiacLauncher/zodiacAuth';
import './style.css';
import CrossIcon from '../../assets/header-icons/cross';
import CrossIconNew from '../../assets/updated/cross_white.png';

// import Fantasy_Lotto from '../../assets/BSheader/fantasy.png';
// import token from '../../assets/BSheader/tokens icon 1.svg';
// import token_white from '../../assets/BSheader/tokens icon  white (1).svg';
import { auth_header_data, auth_header_data_asset_wallet } from './data';
import header_data from './data';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// import Container from 'react-bootstrap/Container';
// import Nav from 'react-bootstrap/Nav';
// import Navbar from 'react-bootstrap/Navbar';
// import NavDropdown from 'react-bootstrap/NavDropdown';
import { useLocation, useSearchParams } from 'react-router-dom';
import './Header.css';
// import loaderGif from '../../assets/arts/loaderIcon.gif';
// import hive from '../../assets/BSheader/hive logo HD2 1.svg';

import frame from '../../assets/updated/header/captain.png';
import beeframe from '../../assets/updated/header/normal.png';

import dummy from '../../assets/hive-dashboard/dummy.png';
import { useTheme } from '@mui/material';
import { useMediaQuery } from '@mui/material';

import { useNavigate } from 'react-router-dom';

// import {
//   baseURL,
//   baseCEXURL,
//   getCaptainBeeStatics,
//   getHoneyUserDetails,
//   baseDEXURL,
//   baseHiveURL,
//   baseMktplaceURL,
//   baseShopURL,
//   baseWSURL,
//   baseWalletURL,
//   baseXnftURL,
//   baseAcademyUrl,
//   decodeJWT,
//   checkEmail,
//   checkByemail,
//   getCaptainBeeByEmail,
// } from '../../services/api';

import {
  baseURL,
  getCaptainBeeStatics,
  getHoneyUserDetails,
  baseWalletURL,
  decodeJWT,
  checkByemail,
  getCaptainBeeByEmail,
} from '../../services/api';
import { getKycStatus } from '../../services/kycApi';
import { getKybStatus } from '../../services/kybApi';

import DarkMode from '../DarkMode/DarkMode';
// import { Button } from 'react-bootstrap';

const Links = [
  { label: 'Exchange', value: 'buy-sell', url: '/indexx-exchange/buy-sell' },
  {
    label: 'Trade To Earn',
    value: 'trade-to-earn',
    url: '/indexx-exchange/trade-to-earn',
  },
  { label: 'Markets', value: 'markets', url: '/indexx-exchange/markets' },
  { label: 'Tokens', value: 'tokens', url: '/indexx-exchange/tokens' },
  { label: 'Blog', value: 'blog', url: '/indexx-exchange/blog' },
  { label: 'Vlog', value: 'vlog', url: '/indexx-exchange/vlog' },
  { label: 'About', value: 'about', url: '/indexx-exchange/about' },
  { label: 'Careers', value: 'careers', url: '/indexx-exchange/careers' },
  {
    label: 'Notifications',
    value: 'notification',
    url: '/indexx-exchange/notification',
  },
  {
    label: 'How it Works',
    value: 'how-it-works',
    url: '/indexx-exchange/how-it-works',
  },
  { label: '', value: '/', url: '/' },
];

const HeaderTest = () => {
  const theme = useTheme() as any;
  const isAuthenticated = localStorage.getItem('access_token') !== null;
  const { pathname } = useLocation();
  const [backdropVisibility, setBackdropVisibility] = useState(false);
  const elementRef = useRef(null);

  //   const isAuthenticated = false;

  //   const [activeIndex, setactiveIndex] = useState(0);
  //   const [iconicHeaderData, setIconicHeaderData] = useState(
  //     header_data
  //       .find((el) => el.active === true)
  //       ?.dropDownContent.find((elem) => elem.mainList === true)?.links
  //   );let title = <>{String(localStorage.getItem('user')).toLowerCase()}</>;
  const [, setIsInsideApp] = useState(false);
  const timeoutRef = useRef<any>(null);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [staticsData, setStaticsData] = useState();
  const [honeyBeeData, setHoneyBeeData] = useState<Record<string, any>>();
  const [honeybeeCreateDate, setHoneybeeCreateDate] = useState();
  const [isCaptain, setisCaptain] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userProfile, setUserProfile] = useState();
  const [profileLoading, setProfileLoading] = useState(true);
  const [url, setUrl] = useState('');
  const [loginUserType, setLoginUserType] = useState<any>();
  const [haspowerpack, setHaspowerpack] = useState(false);
  const [authHeader, setAuthHeader] = useState(header_data);
  const navigate = useNavigate();
  console.log(haspowerpack, 'has pack');

  /*
   * Zodiac writes the session AFTER this header has painted — a silent
   * sign-in is a network round trip — so every localStorage read below was
   * made against storage that was still empty. The shared client used to force
   * a full page reload to fix that, at the cost of a second /id/token grant and
   * a visible flash; it now fires "zodiac:session" instead. Bumping this
   * counter re-renders (isAuthenticated and userEmail are read at render) and
   * re-runs the session-derived effects in place. This header is the only
   * place the product reads its session, so the listener belongs here.
   * See applyEstateSession in ZodiacLauncher/zodiacAuth.js.
   */
  const [sessionVersion, setSessionVersion] = useState(0);

  useEffect(() => {
    const onZodiacSession = () => setSessionVersion((v) => v + 1);
    window.addEventListener('zodiac:session', onZodiacSession);
    return () => window.removeEventListener('zodiac:session', onZodiacSession);
  }, []);

  useEffect(() => {
    const userType =
      localStorage.getItem('userType') !== undefined
        ? String(localStorage.getItem('userType'))
        : undefined;

    setLoginUserType(userType);
  }, [sessionVersion]);
  let pageName = searchParams.get('page');
  // alert(pageName)
  useEffect(() => {
    if (location) {
      setIsInsideApp(location.pathname.includes('/indexx-exchange/'));
    }
  }, [location]);

  useEffect(() => {
    setAuthHeader(
      header_data.map((el) => {
        if (
          pathname.includes('/crypto-treasury') ||
          pathname.includes('/smart-crypto') ||
          pathname.includes('/smart-apy')
        ) {
          if (el.mainTextDesktop === 'Crypto Treasury') {
            return { ...el, active: true };
          }
          if (el.mainTextDesktop === 'Exchange / Buy Crypto') {
            return { ...el, active: false };
          }
        } else {
          if (el.mainTextDesktop === 'Exchange / Buy Crypto') {
            return { ...el, active: true };
          }
        }

        // In all other cases, set 'active' to false
        return { ...el, active: false };
      })
    );
  }, [pathname]);

  const showText: any = Links.filter((link) =>
    window.location.pathname.includes(link.value)
  ).map((obj) => obj.label);
  // const showUrl: any = Links.filter((link) =>
  //   window.location.pathname.includes(link.value)
  // ).map((obj) => obj.url);
  useEffect(() => {
    showText[0] !== ''
      ? (document.title = `${showText[0]} | indexx.ai`)
      : pageName
        ? (document.title = `${pageName} | indexx.ai`)
        : (document.title = 'indexx.ai');
  }, [showText, pageName]);
  useEffect(() => {
    async function checkUserType() {
      let userType =
        localStorage.getItem('userType') !== undefined
          ? String(localStorage.getItem('userType'))
          : undefined;
      let username =
        localStorage.getItem('username') !== undefined
          ? String(localStorage.getItem('username'))
          : undefined;

      const user =
        localStorage.getItem('user') !== undefined
          ? String(localStorage.getItem('user'))
          : undefined;

      const email =
        localStorage.getItem('email') !== undefined
          ? String(localStorage.getItem('email'))
          : undefined;

      let getUserType = await checkByemail(String(email));
      userType = getUserType.userType;

      const accessToken =
        localStorage.getItem('access_token') !== undefined
          ? String(localStorage.getItem('access_token'))
          : undefined;

      if (userType === 'CaptainBee') {
        if (accessToken && accessToken !== 'null' && accessToken !== '') {
          let resObj = await getCaptainBeeByEmail(String(email));
          console.log('resObj', resObj);
          username = resObj?.data.Username;
        }
        setisCaptain(true);
        setLoading(false);

        if (username) {
          getCaptainBeeStatics(String(username)).then((data) => {
            setUserProfile(data?.data?.affiliateUserProfile?.photoIdFileurl);
            setProfileLoading(false);
            console.log(
              'index header',
              data?.data?.affiliateUserProfile?.photoIdFileurl
            );
            setStaticsData(data.data);
            if (
              data?.data?.powerPackData !== undefined &&
              data?.data?.powerPackData !== null &&
              data?.data?.powerPackData !== ''
            ) {
              setHaspowerpack(true);
            }
          });
        }
      } else {
        setisCaptain(false);
        setLoading(false);
        getHoneyUserDetails(String(user)).then(async (data) => {
          console.log('data', data);
          setHoneybeeCreateDate(data.data.accountCreationDate);

          // Get the latest KYC/KYB status from their respective endpoints
          let latestKycStatus = null;
          let latestKybStatus = null;

          try {
            const kycStatusRes = await getKycStatus();
            latestKycStatus = (kycStatusRes as any).data?.data || (kycStatusRes as any).data;
          } catch (kycError: any) {
            if (kycError.response?.status !== 404) {
              console.log('Could not check KYC status:', kycError);
            }
          }

          try {
            const kybStatusRes = await getKybStatus();
            latestKybStatus = (kybStatusRes as any).data?.data || (kybStatusRes as any).data;
          } catch (kybError: any) {
            if (kybError.response?.status !== 404) {
              console.log('Could not check KYB status:', kybError);
            }
          }

          // Merge user data with latest KYC/KYB status
          const userDoc = data?.data?._doc || {};
          const updatedUserData = {
            ...userDoc,
            // Override with latest KYC status if available
            ...(latestKycStatus?.status === 'approved' || latestKycStatus?.status === 'Completed' ? {
              isKYCPass: true,
              kycStatus: 'Completed'
            } : {}),
            // Override with latest KYB status if available
            ...(latestKybStatus?.application?.status === 'approved' ? {
              isKYCPass: true,
              kycStatus: 'Completed'
            } : {})
          };

          setHoneyBeeData(updatedUserData);
          setUserProfile(updatedUserData?.profilePic);
          setProfileLoading(false);

          console.log('Updated user data with KYC/KYB status:', {
            original: userDoc,
            kycStatus: latestKycStatus,
            kybStatus: latestKybStatus,
            updated: updatedUserData
          });
        }).catch((error) => {
          console.error('Error in getHoneyUserDetails promise:', error);
          setProfileLoading(false);
        });
      }
    }
    checkUserType();
  }, [sessionVersion]);

  // Poll for verification status updates every 30 seconds
  useEffect(() => {
    if (!isAuthenticated) return;

    const user = localStorage.getItem('user');
    if (!user) return;

    const pollInterval = setInterval(async () => {
      try {
        const data = await getHoneyUserDetails(String(user));
        const userDoc = data?.data?._doc || {};

        // Get the latest KYC/KYB status from their respective endpoints
        let latestKycStatus = null;
        let latestKybStatus = null;

        try {
          const kycStatusRes = await getKycStatus();
          latestKycStatus = (kycStatusRes as any).data?.data || (kycStatusRes as any).data;
        } catch (kycError: any) {
          if (kycError.response?.status !== 404) {
            console.log('Could not check KYC status:', kycError);
          }
        }

        try {
          const kybStatusRes = await getKybStatus();
          latestKybStatus = (kybStatusRes as any).data?.data || (kybStatusRes as any).data;
        } catch (kybError: any) {
          if (kybError.response?.status !== 404) {
            console.log('Could not check KYB status:', kybError);
          }
        }

        // Merge user data with latest KYC/KYB status
        const updatedUserData = {
          ...userDoc,
          // Override with latest KYC status if approved/completed
          ...(latestKycStatus?.status === 'approved' || latestKycStatus?.status === 'Completed' ? {
            isKYCPass: true,
            kycStatus: 'Completed'
          } : {}),
          // Override with latest KYB status if approved
          ...(latestKybStatus?.application?.status === 'approved' ? {
            isKYCPass: true,
            kycStatus: 'Completed'
          } : {})
        };

        setHoneyBeeData(updatedUserData);
      } catch (error) {
        console.error('Error polling verification status:', error);
      }
    }, 30000); // Poll every 30 seconds

    return () => clearInterval(pollInterval);
  }, [isAuthenticated]);

  useEffect(() => {
    let access_token = String(localStorage.getItem('access_token'));
    console.log('access', access_token);
    if (access_token) {
      try {
        let decoded = decodeJWT(access_token);
        const userEmail = decoded.email;
        const userKey = String(localStorage.getItem('userkey'));
        const userType = localStorage.getItem('userType');
        const userpassword = localStorage.getItem('userpass');
        console.log('userEmail', userEmail);
        console.log('userKey', userKey);
        console.log('userpassword', userpassword);
        const walletUrl = `${baseWalletURL}/login/sign-in/?useremail=${userEmail}&userkey=${userpassword}&usertype=${userType}`;
        setUrl(walletUrl);
      } catch (error) {
        console.error('Error decoding access_token:', error);
        // Handle the error, e.g., show an error message to the user or perform appropriate actions.
      }
    }
  }, [sessionVersion]);

  const [userLogged, setUserLogged] = useState('normal'); // Set the user's type

  const userEmail = localStorage.getItem('user') || '';

  useEffect(() => {
    const user =
      localStorage.getItem('userlogged') !== undefined
        ? setUserLogged(String(localStorage.getItem('userlogged')))
        : setUserLogged('normal');
    const handleStorageChange = (event: any) => {
      // console.log(event);
      if (setUserLogged !== event.currentTarget.localStorage.userlogged)
        setUserLogged(event.currentTarget.localStorage.userlogged);
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const isMobile = useMediaQuery('(max-width:1300px)');

  //   const handleItemClick = (path: string, i: number) => {
  //     setactiveIndex(i);
  //     console.log(path, 'path');
  //   };
  const handleMouseEnter = () => {
    // Set a timeout to open the dropdown after 0.2s
    timeoutRef.current = setTimeout(() => {
      setBackdropVisibility(true);
    }, 200);
  };

  const handleMouseLeave = () => {
    // Clear the timeout if user leaves before 0.2s
    clearTimeout(timeoutRef.current);
    // Hide the dropdown after a delay
    setTimeout(() => {
      setBackdropVisibility(false);
    }, 200);
  };
  const updateBackDropVisibility = (type: string) => {
    if (type === 'enter') handleMouseEnter();
    if (type === 'leave') handleMouseLeave();
  };

  useEffect(() => {
    const element = elementRef.current;

    if (element) {
      const computedStyle = window.getComputedStyle(element);
      const visibility = computedStyle.getPropertyValue('visibility');
      const display = computedStyle.getPropertyValue('display');

      if (visibility === 'hidden' || display === 'none') {
        console.log('Element is hidden or not visible');
      } else {
        console.log('Element is visible');
        setBackdropVisibility(false);
      }
    }
  }, []);

  const logOutUser = async (e: React.MouseEvent<HTMLElement>) => {
    // Synchronous, before any await: the Link above only stays put because
    // React Router sees defaultPrevented on this same tick.
    e.preventDefault();
    const userType =
      localStorage.getItem('userType') !== undefined
        ? String(localStorage.getItem('userType'))
        : undefined;

    // Remove specific authentication items instead of clearing everything
    const itemsToRemove = [
      'user',
      'access_token',
      'refresh_token',
      'userType',
      'username',
      'userlogged',
      'redirected',
      'email',
    ];

    // Remove each item individually
    itemsToRemove.forEach((item) => localStorage.removeItem(item));

    /*
     * And end the session at the PROVIDER, which nothing here did.
     *
     * The keys above are this origin's copy and nothing more. The provider's
     * session row and its idp_session cookie survived them, so the next page
     * load ran prompt=none, found the session still open, and signed the user
     * straight back in — across all sixteen products, and for whoever used the
     * machine next. notifySignedOut revokes the refresh family and navigates
     * to the end-session endpoint, which is what actually ends it.
     *
     * LAST, after our own keys are gone: this navigates and may not come back.
     * It resolves false when no launcher client was ever built on the page —
     * a user who is not signed in to Zodiac — and never throws, so the local
     * redirect below stays the path for exactly that case.
     */
    const ended = await notifySignedOut().catch(() => false);
    if (ended) return;

    // Redirect without the action=Logout parameter
    window.location.href = `${baseURL}/auth/login?action=Logout`;
  };

  const [isAssetWallet, setIsAssetWallet] = useState(false);
  const [hoverAsset, setHoverAsset] = useState('');
  const handleLogout = (e: any, nm: string) => {
    if (nm !== 'logout') return;
    void logOutUser(e);
  };
  const onMouseEnterItem = (name: any) => {
    setHoverAsset(name);
  };

  const onAssetWalletClick = () => {
    setIsAssetWallet(true);
  };
  const onMouseLeaveItem = (name: any) => {
    setHoverAsset('');
  };
  const simpleAuthData = [
    'Account & Settings',
    'Bridge',
    'Hive Dashboard',
    'Notification',
    'Reward Center',
    'Trade to Earn',
    'Logout',
  ];
  let selectedDataFile = simpleAuthData.includes(hoverAsset)
    ? auth_header_data
    : hoverAsset === 'Asset Wallet'
      ? auth_header_data_asset_wallet
      : !simpleAuthData.includes(hoverAsset) && isAssetWallet
        ? auth_header_data_asset_wallet
        : auth_header_data;

  return (
    <>
      <nav style={{ position: 'fixed', top: 0, left: 0, zIndex: 10000 }}>
        <div className="wrapper">
          <div
            className="backdrop"
            style={{
              display: 'block',
              opacity: backdropVisibility ? 1 : 0,
              background:
                theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.5)' : '',
              transitionDelay: '.1s',
              height: backdropVisibility ? '100vh' : 0,
            }}
          ></div>

          <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <div className="logo" style={{ marginRight: '30px' }}>
              <Link to="https://indexx.ai">
                <img
                  src={logo}
                  alt="indexx logo"
                  style={{ marginTop: '-8px' }}
                />
              </Link>
            </div>
            <input type="radio" name="slider" id="menu-btn" />
            <input type="radio" name="slider" id="close-btn" />
            <ul className="nav-links" style={{ flex: 1 }}>
              <label htmlFor="close-btn" className="btn close-btn">
                <img src={CrossIconNew} alt="cross icon " />
              </label>
              {isMobile &&
                auth_header_data
                  .filter((el) => el.isAuth === isAuthenticated)
                  .map((element, i) => (
                    <>
                      {element.mainTextDesktop === 'Logout' ? (
                        <li
                          className="main"
                          style={{
                            marginLeft: i === 0 && !isMobile ? 'auto' : '',
                            cursor: 'pointer',
                          }}
                        // onClick={(e) =>
                        //   handleLogout(
                        //     e,
                        //     element.mainTextDesktop.toLocaleLowerCase()
                        //   )
                        // }
                        >
                          <Link
                            to={element.href}
                            className={`desktop-item ${element.active ? 'link_active' : ''
                              }`}
                            onClick={(e) => handleLogout(e, 'logout')}
                          >
                            Logout
                          </Link>
                          <Link
                            to={element.href}
                            className={`mobile-item ${element.active ? 'link_active' : ''
                              }`}
                            onClick={(e) => handleLogout(e, 'logout')}
                          >
                            Logout
                          </Link>
                        </li>
                      ) : element.mainTextDesktop === 'How it Works' ||
                        element.mainTextDesktop === 'Login' ||
                        element.mainTextDesktop === 'Register' ? (
                        <li
                          className="main"
                          style={{
                            marginLeft: i === 0 && !isMobile ? 'auto' : '',
                          }}
                          onMouseEnter={
                            isAuthenticated
                              ? () => updateBackDropVisibility('enter')
                              : () => updateBackDropVisibility('leave')
                          }
                          onMouseLeave={() => updateBackDropVisibility('leave')}
                        >
                          <Link
                            to={element.href}
                            className={`desktop-item ${element.active ? 'link_active' : ''
                              }`}
                          >
                            {element.mainTextDesktop}
                          </Link>

                          <input type="checkbox" id={element.mainTextDesktop} />
                          <Link to={element.href} className="mobile-item">
                            {element.mainTextDesktop}
                          </Link>
                          {element.hasMegaDrop ? (
                            <div
                              className="mega-box"
                              style={{
                                background:
                                  theme.palette.mode === 'light'
                                    ? '#FAFAFC'
                                    : '',
                                color:
                                  theme.palette.mode === 'light'
                                    ? '#333336 !important'
                                    : '',
                              }}
                              ref={elementRef}
                            >
                              <div className="content">
                                {element.dropDownContent.map((elem) => (
                                  <div
                                    className="row"
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                    }}
                                  >
                                    <header>{elem?.heading}</header>
                                    <ul
                                      className={`mega-links ${elem?.mainList ? 'main' : ''
                                        }`}
                                    >
                                      {elem?.links.map((el) => (
                                        <li>
                                          <Link
                                            to={el.href}
                                            onClick={(e) => {
                                              if (el.logout) {
                                                e.preventDefault();
                                                handleLogout(
                                                  e,
                                                  el.name.toLocaleLowerCase()
                                                );
                                              } else {
                                                handleLogout(
                                                  e,
                                                  el.name.toLocaleLowerCase()
                                                );
                                              }
                                            }}
                                            className={
                                              theme.palette.mode === 'light'
                                                ? 'dark_color'
                                                : ''
                                            }
                                          >
                                            {el.name}
                                          </Link>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                ))}

                                <div className="row"></div>
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </li>
                      ) : (
                        <li
                          className="main"
                          style={{
                            marginLeft: i === 0 ? 'auto' : '',
                          }}
                          onMouseEnter={
                            isAuthenticated
                              ? () => updateBackDropVisibility('enter')
                              : () => updateBackDropVisibility('leave')
                          }
                          onMouseLeave={() => updateBackDropVisibility('leave')}
                        >
                          {!isMobile && isAuthenticated && (
                            <div
                              style={{
                                marginBottom: '-23px',
                                zIndex: '10000000',

                                // transform: 'translateY(10px)',
                              }}
                            >
                              <div
                                style={{
                                  width: isCaptain ? '40px' : '50px',
                                  height: isCaptain ? '40px' : '60px',
                                  // backgroundImage: `url(${
                                  //   isCaptain === true ? frame : beeframe
                                  // })`,
                                  transform: !isCaptain ? 'rotate(-30deg)' : '',
                                  // backgroundImage: `url(${frame})`,
                                  backgroundRepeat: 'no-repeat',
                                  backgroundSize: 'contain',
                                  backgroundPosition: 'center',
                                  position: 'relative',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  alignSelf: 'center',
                                  // border:"none"
                                }}
                              >
                                <div
                                  style={{
                                    width: isCaptain ? '40px' : '50px',
                                    height: isCaptain ? '40px' : '60px',
                                    position: 'absolute',
                                    zIndex: '1',
                                  }}
                                >
                                  <img
                                    src={isCaptain === true ? frame : beeframe}
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                    }}
                                  />
                                </div>
                                <div
                                  className={
                                    isCaptain ? 'bee-hexagon' : 'elipse-img'
                                  }
                                  style={{
                                    marginBottom: `${isCaptain === true ? 0 : '7px'
                                      }`,
                                  }}
                                >
                                  <img
                                    alt=""
                                    src={dummy}
                                    // src={userProfile ? userProfile : dummy}
                                    width={'63px'}
                                    height={'66px'}
                                    style={{
                                      border: 'none',
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                          <Link
                            to={element.href}
                            className={`desktop-item ${element.active ? 'link_active' : ''
                              }`}
                          >
                            {isAuthenticated
                              ? userEmail
                              : element.mainTextDesktop}
                          </Link>

                          <input type="checkbox" id={element.mainTextDesktop} />
                          <label
                            htmlFor={element.mainTextDesktop}
                            className="mobile-item"
                          >
                            {isAuthenticated
                              ? userEmail
                              : element.mainTextDesktop}
                            {element.hasMegaDrop ? ' > ' : ''}
                          </label>
                          {element.hasMegaDrop ? (
                            <div
                              className="mega-box"
                              style={{
                                background:
                                  theme.palette.mode === 'light'
                                    ? '#FAFAFC'
                                    : '',
                                color:
                                  theme.palette.mode === 'light'
                                    ? '#333336 !important'
                                    : '',
                              }}
                              ref={elementRef}
                            >
                              <div className="content">
                                {element.dropDownContent.map((elem) => (
                                  <div
                                    className="row"
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                    }}
                                  >
                                    <header>{elem?.heading}</header>
                                    <ul
                                      className={`mega-links ${elem?.mainList ? 'main' : ''
                                        }`}
                                    >
                                      {elem?.links.map((el) => (
                                        <li>
                                          <Link
                                            to={el.href}
                                            onClick={(e) => {
                                              if (el.logout) {
                                                e.preventDefault();
                                                handleLogout(
                                                  e,
                                                  el.name.toLocaleLowerCase()
                                                );
                                              } else {
                                                handleLogout(
                                                  e,
                                                  el.name.toLocaleLowerCase()
                                                );
                                              }
                                            }}
                                            className={
                                              theme.palette.mode === 'light'
                                                ? 'dark_color'
                                                : ''
                                            }
                                          >
                                            {el.name}
                                          </Link>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                ))}

                                <div className="row"></div>
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </li>
                      )}
                    </>
                  ))}
              {authHeader.map((element) => (
                <>
                  <li
                    className="main"
                    onMouseEnter={() =>
                      updateBackDropVisibility(
                        !element.hasMegaDrop ? '' : 'enter'
                      )
                    }
                    onMouseLeave={() =>
                      updateBackDropVisibility(
                        !element.hasMegaDrop ? '' : 'leave'
                      )
                    }
                  >
                    <Link
                      to={element.href}
                      className={`desktop-item ${element.active ? 'link_active' : ''
                        }`}
                      onMouseEnter={() =>
                        updateBackDropVisibility(
                          !element.hasMegaDrop ? '' : 'enter'
                        )
                      }
                    >
                      {element.mainTextDesktop}
                    </Link>

                    {element.hasMegaDrop ? (
                      <>
                        <input type="checkbox" id={element.mainTextMob} />

                        <label
                          htmlFor={element.mainTextMob}
                          className="mobile-item"
                        >
                          {element.mainTextDesktop}{' '}
                          {element.hasMegaDrop ? '>' : ''}
                        </label>
                      </>
                    ) : (
                      <Link to={element.href} className="mobile-item">
                        {element.mainTextMob}
                      </Link>
                    )}

                    {element.hasMegaDrop ? (
                      <div
                        className="mega-box"
                        style={{
                          background:
                            theme.palette.mode === 'light' ? '#FAFAFC' : '',
                          color:
                            theme.palette.mode === 'light'
                              ? '#333336 !important'
                              : '',
                        }}
                        ref={elementRef}
                      >
                        <div className="content">
                          {element.dropDownContent.map((elem) => (
                            <div
                              className="row"
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                              }}
                            >
                              <header>{elem.heading}</header>
                              <ul
                                className={`mega-links ${elem.mainList ? 'main' : ''
                                  }`}
                              >
                                {elem.links.map((el) => (
                                  <li className={`profile-list-item `}>
                                    <Link
                                      to={el.href}
                                      className={
                                        theme.palette.mode === 'light'
                                          ? 'dark_color'
                                          : ''
                                      }
                                    >
                                      {el.name}
                                    </Link>
                                    <div
                                      className={`profile-inner-item-border-bottom `}
                                      style={{
                                        background: '#11BE6A',
                                        width: '16px',
                                        height: '3px',
                                        marginTop: '-5px',
                                      }}
                                    ></div>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          ))}

                          <div className="row"></div>
                          <div className="row"></div>
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                  </li>
                </>
              ))}

              {!isMobile &&
                selectedDataFile
                  .filter((el) => el.isAuth === isAuthenticated)

                  .map((element, i) => (
                    <>
                      {element.mainTextDesktop === 'Logout' ? (
                        <li
                          className="main"
                          style={{
                            // Zodiac's Dashboard <li> above owns the margin-left:auto now.
                            // First item of this list owns the margin-left:auto
                            // that pushes the cluster right. Only the first —
                            // two autos in one flex row split the free space.
                            marginLeft: i === 0 ? 'auto' : '',
                            display: 'flex',
                            cursor: 'pointer',
                          }}
                        // onClick={(e) =>
                        //   handleLogout(
                        //     e,
                        //     element.mainTextDesktop.toLocaleLowerCase()
                        //   )
                        // }
                        >
                          <Link
                            to={element.href}
                            className={`desktop-item ${element.active ? 'link_active' : ''
                              }`}
                            onClick={(e) => handleLogout(e, 'logout')}
                          >
                            Logout
                          </Link>
                        </li>
                      ) : (
                        <li
                          className="main"
                          style={{
                            // Zodiac's Dashboard <li> above owns the margin-left:auto now.
                            // First item of this list owns the margin-left:auto
                            // that pushes the cluster right. Only the first —
                            // two autos in one flex row split the free space.
                            marginLeft: i === 0 ? 'auto' : '',
                            // display: 'flex',
                          }}
                          onMouseEnter={
                            isAuthenticated
                              ? () => updateBackDropVisibility('enter')
                              : () => updateBackDropVisibility('leave')
                          }
                          onMouseLeave={() => updateBackDropVisibility('leave')}
                        >
                          {!isMobile && isAuthenticated && !loading && (
                            <div
                              style={{
                                marginBottom: '-23px',
                                zIndex: '10000000',

                                // transform: 'translateY(10px)',
                              }}
                            >
                              <div
                                style={{
                                  width: isCaptain ? '60px' : '50px',
                                  height: isCaptain ? '70px' : '60px',
                                  // backgroundImage: `url(${
                                  //   isCaptain === true ? frame : beeframe
                                  // })`,
                                  transform: !isCaptain ? 'rotate(-30deg)' : '',
                                  // backgroundImage: `url(${frame})`,
                                  backgroundRepeat: 'no-repeat',
                                  backgroundSize: 'contain',
                                  backgroundPosition: 'center',
                                  position: 'relative',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  alignSelf: 'center',
                                  // border:"none"
                                }}
                              >
                                <div
                                  style={{
                                    width: isCaptain ? '60px' : '50px',
                                    height: isCaptain ? '70px' : '60px',
                                    position: 'absolute',
                                    zIndex: '1',
                                  }}
                                >
                                  <img
                                    src={isCaptain === true ? frame : beeframe}
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                    }}
                                  />
                                </div>

                                {!profileLoading && (
                                  <div
                                    className={
                                      isCaptain ? 'bee-hexagon' : 'elipse-img'
                                    }
                                    style={{
                                      width: '40px',
                                      height: '40px',
                                      marginBottom: `${isCaptain === true ? 0 : '7px'
                                        }`,
                                    }}
                                  >
                                    <img
                                      alt=""
                                      src={dummy}
                                      // src={userProfile ? userProfile : dummy}
                                      width={'63px'}
                                      height={'75px'}
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                          )}

                          <div
                            style={{
                              // marginTop: '16px',
                              display: 'flex',
                              justifyContent: 'center',
                              flexDirection: 'column',
                              alignItems: 'left',
                            }}
                          >
                            <div
                              style={{
                                marginTop: isAuthenticated ? '30px' : '0px',
                                display: 'flex',
                                flexDirection: 'column',
                                lineHeight: '1',
                              }}
                            >
                              <Link
                                to={element.href}
                                className={`desktop-item ${element.active ? 'link_active' : ''
                                  }`}
                              >
                                {isAuthenticated
                                  ? userEmail
                                  : element.mainTextDesktop}
                              </Link>

                              <input
                                type="checkbox"
                                id={element.mainTextDesktop}
                              />
                              <label
                                htmlFor={element.mainTextDesktop}
                                className="mobile-item"
                              >
                                {isAuthenticated
                                  ? userEmail
                                  : element.mainTextDesktop}
                              </label>
                              {honeyBeeData ? (
                                ((honeyBeeData as any)?.isKYCPass ||
                                  (honeyBeeData as any)?.kycStatus === 'Completed') ? (
                                  <>
                                    <p
                                      className="desktop-item"
                                      style={{
                                        fontSize: '12px',
                                        marginTop: '4px',
                                        padding: '3px 0',
                                        width: '40%',
                                        cursor: 'default',
                                        color: 'rgb(75, 138, 221)',
                                      }}
                                    >
                                      <span
                                        style={{
                                          display: 'inline-flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          gap: '4px',
                                        }}
                                      >
                                        <CheckCircleIcon
                                          sx={{ fontSize: 16 }}
                                        />
                                        <span>Verified</span>
                                      </span>
                                    </p>

                                    <p
                                      className="mobile-item"
                                      style={{
                                        fontSize: '12px',
                                        marginLeft: '20px',
                                        marginTop: '4px',
                                        padding: '3px 0',
                                        width: '30%',
                                        cursor: 'default',
                                        color: 'rgb(75, 138, 221)',
                                      }}
                                    >
                                      <span
                                        style={{
                                          display: 'inline-flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          gap: '4px',
                                        }}
                                      >
                                        <CheckCircleIcon
                                          sx={{ fontSize: 16 }}
                                        />
                                        <span>Verified</span>
                                      </span>
                                    </p>
                                  </>
                                ) : (
                                  <>
                                    <p
                                      className="desktop-item"
                                      onClick={() =>
                                        navigate('/indexx-exchange/account')
                                      }
                                      style={{
                                        fontSize: '12px',
                                        marginTop: '4px',
                                        padding: '3px 0',
                                        width: '50%',
                                        cursor: 'pointer',
                                        color: 'rgb(104, 103, 102)',
                                      }}
                                    >
                                      <span
                                        style={{
                                          display: 'inline-flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          gap: '4px',
                                        }}
                                      >
                                        <span>Unverified</span>
                                      </span>
                                    </p>

                                    <p
                                      className="mobile-item"
                                      onClick={() =>
                                        navigate('/indexx-exchange/account')
                                      }
                                      style={{
                                        fontSize: '12px',
                                        marginLeft: '20px',
                                        marginTop: '4px',
                                        padding: '3px 0',
                                        width: '30%',
                                        cursor: 'pointer',
                                        color: 'rgb(104, 103, 102)',
                                      }}
                                    >
                                      <span
                                        style={{
                                          display: 'inline-flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          gap: '4px',
                                        }}
                                      >
                                        <span>Unverified</span>
                                      </span>
                                    </p>
                                  </>
                                )
                              ) : null}
                            </div>
                          </div>

                          {element.hasMegaDrop ? (
                            <div
                              className="mega-box"
                              style={{
                                background:
                                  theme.palette.mode === 'light'
                                    ? '#FAFAFC'
                                    : '',
                                color:
                                  theme.palette.mode === 'light'
                                    ? '#333336 !important'
                                    : '',
                              }}
                              ref={elementRef}
                            >
                              <div className="content">
                                {element.dropDownContent.map((elem) => (
                                  <div
                                    className="row"
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                    }}
                                  >
                                    <header>{elem?.heading}</header>
                                    <ul
                                      className={`mega-links ${elem?.mainList ? 'main' : ''
                                        }`}
                                    >
                                      {elem?.links.map((el) =>
                                        el.name === 'Hive Dashboard' &&
                                          loginUserType !== 'CaptainBee' ? (
                                          ''
                                        ) : (
                                          <li
                                            style={{
                                              display: 'flex',
                                              flexDirection: 'column',

                                              textAlign: 'left',
                                            }}
                                            onMouseLeave={() =>
                                              onMouseLeaveItem(el.name)
                                            }
                                            onMouseEnter={() =>
                                              onMouseEnterItem(el.name)
                                            }
                                            className="profile-list-item"
                                          >
                                            {el.name.toLowerCase() ===
                                              'asset wallet' ? (
                                              <Link
                                                to={el.href}
                                                onClick={(e) => {
                                                  if (el.logout) {
                                                    e.preventDefault();
                                                    handleLogout(
                                                      e,
                                                      el.name.toLocaleLowerCase()
                                                    );
                                                  } else {
                                                    handleLogout(
                                                      e,
                                                      el.name.toLocaleLowerCase()
                                                    );
                                                  }
                                                }}
                                                className={
                                                  theme.palette.mode === 'light'
                                                    ? 'dark_color'
                                                    : ''
                                                }
                                              >
                                                {el.name}
                                              </Link>
                                            ) : (
                                              <Link
                                                to={el.href}
                                                onClick={(e) =>
                                                  handleLogout(
                                                    e,
                                                    el.name.toLocaleLowerCase()
                                                  )
                                                }
                                                className={
                                                  theme.palette.mode === 'light'
                                                    ? 'dark_color'
                                                    : ''
                                                }
                                              >
                                                {el.name}
                                              </Link>
                                            )}

                                            <div
                                              className={`profile-inner-item-border-bottom ${isAssetWallet &&
                                                el.name === 'Asset Wallet' &&
                                                'active-wallet'
                                                }`}
                                              style={{
                                                background: '#11BE6A',
                                                width: '16px',
                                                height: '3px',
                                                marginTop: '-5px',
                                              }}
                                            ></div>
                                          </li>
                                        )
                                      )}
                                    </ul>
                                  </div>
                                ))}

                                <div className="row"></div>
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </li>
                      )}
                    </>
                  ))}
            </ul>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {/* Zodiac sits at the top RIGHT, immediately left of the theme
                switcher (Brian's call). Exchange and Crypto Treasury share this
                repo, so the current product is derived from the route. */}
            <span style={{ display: 'flex', alignItems: 'center', marginRight: 14 }}>
              <ZodiacLauncher
                productId={
                  typeof window !== 'undefined' &&
                  window.location.pathname.toLowerCase().includes('crypto-treasury')
                    ? 'treasury'
                    : 'exchange'
                }
                tone="dark"
                /* reloadOnSession: this header listens for "zodiac:session"
                   (see sessionVersion above) and re-reads the session in
                   place, so the shared client's full page reload — and the
                   second /id/token grant and "Signing you in…" flash it cost —
                   is no longer what rescues a stale render. */
                auth={{ clientId: "indexx-exchange", reloadOnSession: false }}
              />
            </span>
            <DarkMode />
            <label htmlFor="menu-btn" className="btn menu-btn">
              <CrossIcon />
            </label>
          </div>
        </div>
      </nav>
      {/* <div
        className="secondary_header_root"
        style={{ background: theme === 'dark' ? '#000' : '' }}
      >
        <div className="secondary_header_content">
          {iconicHeaderData?.map((curr: any, i) => (
            <div
              key={i}
              className={`secondary_header_content_item ${
                i === activeIndex ? 'active' : ''
              }`}
              onClick={() => handleItemClick(curr.href, i)}
            >
              <span className="secondary_header_content_img_container">
                <img
                  src={
                    theme !== 'light'
                      ? curr?.imgLight ?? token_white
                      : curr?.imgDark ?? token
                  }
                />
              </span>
              <span>{curr.name}</span>
            </div>
          ))}
        </div>
      </div> */}
    </>
  );
};

export default HeaderTest;
